import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import { CustomPeriod } from 'modules/attendance/store/models/Period'

class CustomPeriods extends Collection<CustomPeriod> {
  get cacheKey(): string {
    return 'customPeriods'
  }

  model() {
    return CustomPeriod
  }
}

const singleton: CustomPeriods = new CustomPeriods()

export default singleton

const { provider: CustomPeriodsProvider, hook: useCustomPeriods } = createCollectionContext<
  CustomPeriod,
  CustomPeriods
>()
